export const toInt = (v: unknown): number => {
	const n = typeof v === 'string' ? parseInt(v, 10) : Number(v);
	return Number.isFinite(n) ? n : 0;
};
